import React, { useEffect } from 'react'
import { Result, Button } from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useCustomerAuth } from '../contexts/CustomerAuthContext'
import { env } from '../config/environment'

export const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate()
  const { invoiceId } = useParams<{ invoiceId: string }>()
  const [searchParams] = useSearchParams()
  const { portalConfig } = useCustomerAuth()

  useEffect(() => {
    const sessionId = searchParams.get('session_id')
    if (sessionId) {
      const apiUrl = `${env.apiBaseUrl.replace(/\/api$/, '')}/api/public/payment/session/${sessionId}${invoiceId ? `?invoice_id=${invoiceId}` : ''}`
      fetch(apiUrl).catch(() => {})
    }
  }, [invoiceId, searchParams])

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '60vh',
      padding: '24px'
    }}>
      <Result
        icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
        status="success"
        title="Payment Successful!"
        subTitle="Your payment has been processed successfully. You will receive a confirmation email shortly."
        extra={[
          <Button 
            type="primary" 
            key="invoices"
            onClick={() => navigate('/invoices')}
          >
            View All Invoices
          </Button>,
          <Button 
            key="invoice-details"
            onClick={() => navigate(`/invoices/${invoiceId}`)}
          >
            View Invoice Details
          </Button>,
          <Button 
            key="dashboard"
            onClick={() => navigate(portalConfig?.defaultLandingPage || '/dashboard')}
          >
            Back to Dashboard
          </Button>
        ]}
      />
    </div>
  )
}
